import AccountService, { IAccountService } from './AccountService'
import AggregateFieldService from './AggregateFieldService'
import ApiService from './ApiService'
import CalendarService from './CalendarService'
import CardSettingService from './CardSettingService'
import ClientDataSourceService from './ClientDataSourceService'
import ClientService from './ClientService'
import DashboardService from './DashboardService'
import DataSyncService from './DataSyncService'
import FormulaFieldService from './FormulaFieldService'
import JumpLinksService from './JumpLinksService'
import LocationService from './LocationService'
import LoggingService from './LoggingService'
import MailMergeService from './MailMergeService'
import QuantumChartReportService from './QuantumChartReportService'
import ReportService from './ReportService'
import RouteService from './RouteService'
import StackGmapService from './StackGmapService'
import ThemeSettingsService from './ThemeSettingsService'
import UserService from './UserService'

const loggingService = new LoggingService()
const apiService = new ApiService(loggingService)
const locationService = new LocationService(loggingService)
const stackGmapService = new StackGmapService(loggingService)
const cardSettingService = new CardSettingService(loggingService)
const themeSettingsService = new ThemeSettingsService(loggingService)
const jumpLinksService = new JumpLinksService(loggingService)
const reportService = new ReportService(loggingService)
const quantumChartReportService = new QuantumChartReportService(loggingService)
const clientService = new ClientService(loggingService)
const clientDataSourceService = new ClientDataSourceService(loggingService)

const userService = new UserService(apiService, loggingService)
const accountService = new AccountService(apiService, loggingService) as IAccountService
const aggregateFieldService = new AggregateFieldService(loggingService)
const formulaFieldService = new FormulaFieldService(loggingService)
const dataSyncService = new DataSyncService(loggingService)
const routeService = new RouteService(loggingService)
const dashboardService = new DashboardService(loggingService)
const calendarService = new CalendarService(loggingService)
const mailMergeService = new MailMergeService(loggingService)

export {
    accountService,
    aggregateFieldService,
    calendarService,
    cardSettingService,
    clientDataSourceService,
    clientService,
    dashboardService,
    dataSyncService,
    formulaFieldService,
    jumpLinksService,
    locationService,
    mailMergeService,
    quantumChartReportService,
    reportService,
    routeService,
    stackGmapService,
    themeSettingsService,
    userService
}

